import {
  SchedulerState,
  SchedulerAction,
  SchedulerActionType,
} from './BlockBuilderProspectScheduler.types';

export const INITIAL_STATE: SchedulerState = {
  firstName: '',
  lastName: '',
  postalCode: '',
  referredByCode: '',
  dealers: [],
  selectedDealer: null,
  loading: false,
  loadingMessage: '',
  error: null,
  appointmentData: {
    workTypes: [],
  },
  stage: 'personalDetails',
  email: '',
  phoneNumber: '',
  streetAddress: '',
  city: '',
  stateAbbr: '',
  country: '',
  confirmationScenario: null,
  confirmedAppointmentData: null,
  appointmentDays: [],
  appointmentTimes: [],
  appointmentNotAvailable: false,
  workType: '',
  selectedSlot: null,
};

export function formReducer(
  state: SchedulerState,
  action: SchedulerAction
): SchedulerState {
  switch (action.type) {
    case SchedulerActionType.SET_PERSONAL_DETAIL_FIELD:
      return { ...state, [action.field]: action.value };
    case SchedulerActionType.SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        loadingMessage: action.loadingMessage || '',
        error: null,
      };
    case SchedulerActionType.SET_DEALER_FETCH_SUCCESS:
      return { ...state, dealers: action.dealers || [] };
    case SchedulerActionType.SET_APPOINTMENTS:
      return {
        ...state,
        loading: false,
        appointmentData: action.appointments || state.appointmentData,
      };
    case SchedulerActionType.SET_SELECTED_DEALER:
      return { ...state, selectedDealer: action.dealer || null };
    case SchedulerActionType.SET_ERROR:
      return { ...state, loading: false, error: action.error };
    case SchedulerActionType.SET_STAGE:
      return { ...state, stage: action.stage };
    case SchedulerActionType.SET_CONFIRMATION_SCENARIO:
      return {
        ...state,
        confirmationScenario: action.confirmationScenario,
        confirmedAppointmentData: action.confirmedAppointmentData || null,
      };
    case SchedulerActionType.SET_APPOINTMENT_DAYS:
      return { ...state, appointmentDays: action.appointmentDays || [] };
    case SchedulerActionType.SET_APPOINTMENT_TIMES:
      return { ...state, appointmentTimes: action.appointmentTimes || [] };
    case SchedulerActionType.SET_APPOINTMENT_DAYS_TIMES_AND_WORKTYPE:
      return {
        ...state,
        appointmentDays: action.appointmentDays || [],
        appointmentTimes: action.appointmentTimes || [],
        workType: action.workType,
      };
    case SchedulerActionType.SET_SELECTED_SLOT:
      return { ...state, selectedSlot: action.selectedSlot };
    case SchedulerActionType.SET_APPOINTMENT_NOT_AVAILABLE:
      return {
        ...state,
        appointmentNotAvailable: action.appointmentNotAvailable,
      };
    default:
      return state;
  }
}
